import React from 'react';
import { isMobile } from 'react-device-detect';
import QRCode from 'react-qr-code';

const DesktopBlocker = ({ children }) => {
  if (isMobile) {
    return children;
  }

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: '#2E3546', // Dark background from App.css
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      padding: '20px',
      textAlign: 'center',
      color: 'white'
    }}>
      <div style={{
        backgroundColor: '#111922', // Card background from App.css
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.3)',
        maxWidth: '450px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}>
        <h2 style={{
          marginBottom: '20px',
          color: 'white',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
          fontWeight: '300'
        }}>
          Abre <b style={{ fontWeight: '700' }}>Zenthor</b> desde tu móvil
        </h2>

        <div style={{
          background: 'white',
          padding: '16px',
          borderRadius: '16px',
          display: 'inline-block',
          marginBottom: '24px'
        }}>
          <QRCode
            value="https://app.zenthorapp.io/"
            size={220}
            style={{ height: "auto", maxWidth: "100%", width: "100%" }}
            viewBox={`0 0 256 256`}
          />
        </div>

        <p style={{
          color: 'rgba(255, 255, 255, 0.9)',
          fontSize: '19px',
          lineHeight: '1.6',
          marginBottom: '0',
          maxWidth: '85%'
        }}>
          <b style={{ fontWeight: '700' }}>Zenthor</b> está optimizado para disfrutarse desde tu móvil y ofrecerte la mejor experiencia.
        </p>
      </div>
    </div>
  );
};

export default DesktopBlocker;
